"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * eXtend Media Paywall Service API
 * Media Wall API Specification
 *
 * The version of the OpenAPI document: v1
 * Contact: t.ioannidis@extend.gr
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The UpdateSubscriptionDistributionPermissionsCommand model module.
 * @module model/UpdateSubscriptionDistributionPermissionsCommand
 * @version 1.1.3-alpha.1
 */
class UpdateSubscriptionDistributionPermissionsCommand {
  /**
   * Constructs a new <code>UpdateSubscriptionDistributionPermissionsCommand</code>.
   * @alias module:model/UpdateSubscriptionDistributionPermissionsCommand
   * @param id {String} 
   * @param subscription_type_id {String} 
   * @param distribution_plan_id {String} 
   * @param full_report_available {Boolean} 
   * @param webinar_available {Boolean} 
   */
  constructor(id, subscription_type_id, distribution_plan_id, full_report_available, webinar_available) {
    UpdateSubscriptionDistributionPermissionsCommand.initialize(this, id, subscription_type_id, distribution_plan_id, full_report_available, webinar_available);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, id, subscription_type_id, distribution_plan_id, full_report_available, webinar_available) {
    obj['id'] = id;
    obj['subscription_type_id'] = subscription_type_id;
    obj['distribution_plan_id'] = distribution_plan_id;
    obj['full_report_available'] = full_report_available;
    obj['webinar_available'] = webinar_available;
  }

  /**
   * Constructs a <code>UpdateSubscriptionDistributionPermissionsCommand</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/UpdateSubscriptionDistributionPermissionsCommand} obj Optional instance to populate.
   * @return {module:model/UpdateSubscriptionDistributionPermissionsCommand} The populated <code>UpdateSubscriptionDistributionPermissionsCommand</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new UpdateSubscriptionDistributionPermissionsCommand();
      if (data.hasOwnProperty('id')) {
        obj['id'] = _ApiClient.default.convertToType(data['id'], 'String');
      }
      if (data.hasOwnProperty('subscription_type_id')) {
        obj['subscription_type_id'] = _ApiClient.default.convertToType(data['subscription_type_id'], 'String');
      }
      if (data.hasOwnProperty('distribution_plan_id')) {
        obj['distribution_plan_id'] = _ApiClient.default.convertToType(data['distribution_plan_id'], 'String');
      }
      if (data.hasOwnProperty('full_report_unlock_limit')) {
        obj['full_report_unlock_limit'] = _ApiClient.default.convertToType(data['full_report_unlock_limit'], 'Number');
      }
      if (data.hasOwnProperty('slide_notes_available')) {
        obj['slide_notes_available'] = _ApiClient.default.convertToType(data['slide_notes_available'], 'Boolean');
      }
      if (data.hasOwnProperty('slide_comments_available')) {
        obj['slide_comments_available'] = _ApiClient.default.convertToType(data['slide_comments_available'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_unlocked')) {
        obj['full_report_unlocked'] = _ApiClient.default.convertToType(data['full_report_unlocked'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_unlocked')) {
        obj['webinar_unlocked'] = _ApiClient.default.convertToType(data['webinar_unlocked'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_available')) {
        obj['full_report_available'] = _ApiClient.default.convertToType(data['full_report_available'], 'Boolean');
      }
      if (data.hasOwnProperty('webinar_available')) {
        obj['webinar_available'] = _ApiClient.default.convertToType(data['webinar_available'], 'Boolean');
      }
      if (data.hasOwnProperty('full_report_unlocked_period')) {
        obj['full_report_unlocked_period'] = _ApiClient.default.convertToType(data['full_report_unlocked_period'], 'Number');
      }
      if (data.hasOwnProperty('webinar_unlocked_period')) {
        obj['webinar_unlocked_period'] = _ApiClient.default.convertToType(data['webinar_unlocked_period'], 'Number');
      }
      if (data.hasOwnProperty('webinar_unlock_limit')) {
        obj['webinar_unlock_limit'] = _ApiClient.default.convertToType(data['webinar_unlock_limit'], 'Number');
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>UpdateSubscriptionDistributionPermissionsCommand</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateSubscriptionDistributionPermissionsCommand</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of UpdateSubscriptionDistributionPermissionsCommand.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['id'] && !(typeof data['id'] === 'string' || data['id'] instanceof String)) {
      throw new Error("Expected the field `id` to be a primitive type in the JSON string but got " + data['id']);
    }
    // ensure the json data is a string
    if (data['subscription_type_id'] && !(typeof data['subscription_type_id'] === 'string' || data['subscription_type_id'] instanceof String)) {
      throw new Error("Expected the field `subscription_type_id` to be a primitive type in the JSON string but got " + data['subscription_type_id']);
    }
    // ensure the json data is a string
    if (data['distribution_plan_id'] && !(typeof data['distribution_plan_id'] === 'string' || data['distribution_plan_id'] instanceof String)) {
      throw new Error("Expected the field `distribution_plan_id` to be a primitive type in the JSON string but got " + data['distribution_plan_id']);
    }
    return true;
  }
}
UpdateSubscriptionDistributionPermissionsCommand.RequiredProperties = ["id", "subscription_type_id", "distribution_plan_id", "full_report_available", "webinar_available"];

/**
 * @member {String} id
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['id'] = undefined;

/**
 * @member {String} subscription_type_id
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['subscription_type_id'] = undefined;

/**
 * @member {String} distribution_plan_id
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['distribution_plan_id'] = undefined;

/**
 * @member {Number} full_report_unlock_limit
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['full_report_unlock_limit'] = undefined;

/**
 * @member {Boolean} slide_notes_available
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['slide_notes_available'] = undefined;

/**
 * @member {Boolean} slide_comments_available
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['slide_comments_available'] = undefined;

/**
 * @member {Boolean} full_report_unlocked
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['full_report_unlocked'] = undefined;

/**
 * @member {Boolean} webinar_unlocked
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['webinar_unlocked'] = undefined;

/**
 * @member {Boolean} full_report_available
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['full_report_available'] = undefined;

/**
 * @member {Boolean} webinar_available
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['webinar_available'] = undefined;

/**
 * @member {Number} full_report_unlocked_period
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['full_report_unlocked_period'] = undefined;

/**
 * @member {Number} webinar_unlocked_period
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['webinar_unlocked_period'] = undefined;

/**
 * @member {Number} webinar_unlock_limit
 */
UpdateSubscriptionDistributionPermissionsCommand.prototype['webinar_unlock_limit'] = undefined;
var _default = UpdateSubscriptionDistributionPermissionsCommand;
exports.default = _default;